import { useLocation } from 'react-router-dom';
import { useUpdateEffect } from './useUpdateEffect';

export const usePathNameChanged = (effect) => {
  const { pathname } = useLocation();
  useUpdateEffect(effect, [pathname]);
};
